module.exports = __webpack_public_path__ + "img/game--sims-4--pegi.39ea6844.png";